import { z } from "zod";
import { baseEntitySchema } from "./base";

export const phoneValidationPhoneTypeSchema = z.enum([
  "mobile",
  "landline",
  "voip",
  "unknown",
]);

export const phoneValidationStatusSchema = z.enum([
  "success",
  "error",
  "skipped",
]);

export const phoneValidationResultSchema = z.object({
  id: z.string(),
  validationTimestamp: z.date(),
  customerId: z.string(),
  submissionId: z.string().optional(),
  originalPhone: z.string(),
  normalizedPhone: z.string().optional(),
  valid: z.boolean(),
  phoneType: phoneValidationPhoneTypeSchema,
  carrierName: z.string().optional(),
  country: z.string().length(2).optional(),
  responseTimeMs: z.number().min(0),
  errorCode: z.string().optional(),
  errorMessage: z.string().optional(),
  validationStatus: phoneValidationStatusSchema,
  source: z.string(),
  environment: z.string(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type PhoneValidationResult = z.infer<typeof phoneValidationResultSchema>;

export const customerDealDeduplicationEventSchema = z.object({
  duplicateSubmissionTimestamp: z.date(),
  matchedExistingDealId: z.string(),
  submittedProduct: z.string(),
  businessType: z.string(),
  quantity: z.number(),
  statusMembershipLevel: z.string().nullable(),
  reason: z.string(),
  resubmissionCount: z.number(),
  submissionKey: z.string(),
});

export type CustomerDealDeduplicationEvent = z.infer<
  typeof customerDealDeduplicationEventSchema
>;

export const customerDataSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().email(),
  phone: z.string().min(1),
  dealDeduplicationEvents: z
    .array(customerDealDeduplicationEventSchema)
    .optional(),
  latestPhoneValidation: phoneValidationResultSchema.optional(),
  phoneValidationHistory: z.array(phoneValidationResultSchema).optional(),
});

export type CustomerData = z.infer<typeof customerDataSchema>;
export const customerSchema = baseEntitySchema.merge(customerDataSchema);
export type Customer = z.infer<typeof customerSchema>;
